"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateEffect = void 0;
const react_1 = require("react");
function useUpdateEffect(effect, deps) {
    const mounted = react_1.useRef(false);
    react_1.useEffect(() => {
        if (mounted.current === false) {
            mounted.current = true;
        }
        else {
            return effect();
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [...(deps !== null && deps !== void 0 ? deps : [])]);
}
exports.useUpdateEffect = useUpdateEffect;
//# sourceMappingURL=update-effect.js.map